import { useT } from './i18n'

/** Brand-coloured pelican on a bicycle for the hero and empty states (decorative). */
export function PelicanArt({ animated = true }: { animated?: boolean }) {
  const t = useT()
  const spin = (cx: number) => animated
    ? <animateTransform attributeName="transform" type="rotate" from={`0 ${cx} 452`} to={`360 ${cx} 452`} dur="1.6s" repeatCount="indefinite" />
    : null
  return (
    <svg viewBox="0 0 800 600" role="img" aria-label={t.art.pelicanAria} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <pattern id="pa-grid" width="16" height="16" patternUnits="userSpaceOnUse">
          <path d="M16 0H0V16" fill="none" stroke="#ffffff" strokeOpacity=".07" />
        </pattern>
      </defs>
      <rect width="800" height="600" fill="#0e0b1a" />
      <rect width="800" height="600" fill="url(#pa-grid)" />
      <circle cx="130" cy="120" r="54" fill="#d9ff43" />
      <rect x="0" y="540" width="800" height="60" fill="#8b6fff" />
      <rect x="0" y="536" width="800" height="6" fill="#d9ff43" />

      {/* wheels */}
      {[230, 560].map((cx) => (
        <g key={cx}>
          <circle cx={cx} cy="452" r="84" fill="none" stroke="#f2f0f3" strokeWidth="14" />
          <g>
            {spin(cx)}
            {[0, 45, 90, 135].map((a) => (
              <line key={a} x1={cx} y1="372" x2={cx} y2="532" stroke="#8b6fff" strokeWidth="4" transform={`rotate(${a} ${cx} 452)`} />
            ))}
          </g>
          <circle cx={cx} cy="452" r="10" fill="#d9ff43" />
        </g>
      ))}

      {/* frame */}
      <g fill="none" stroke="#d9ff43" strokeWidth="12" strokeLinecap="square" strokeLinejoin="miter">
        <path d="M230 452 L360 452 L470 330 L300 330 Z" />
        <path d="M360 452 L300 330" />
        <path d="M470 330 L560 452" />
        <path d="M470 330 L490 268 L540 262" />
        <path d="M300 330 L288 300" />
      </g>
      <rect x="258" y="288" width="64" height="14" fill="#f2f0f3" />

      {/* pelican */}
      <g>
        <ellipse cx="350" cy="250" rx="112" ry="64" fill="#f2f0f3" />
        <path d="M262 236 Q300 196 360 210 L330 262 Z" fill="#8b6fff" />
        <path d="M430 210 Q462 150 452 110" fill="none" stroke="#f2f0f3" strokeWidth="34" strokeLinecap="round" />
        <circle cx="456" cy="102" r="36" fill="#f2f0f3" />
        <circle cx="468" cy="94" r="6" fill="#0e0b1a" />
        <path d="M486 96 L640 128 L486 124 Z" fill="#d9ff43" />
        <path d="M486 124 Q560 168 610 130 L486 124 Z" fill="#f8c537" />
        {/* wing to the handlebar */}
        <path d="M398 232 Q470 236 528 262" fill="none" stroke="#f2f0f3" strokeWidth="18" strokeLinecap="round" />
        {/* legs to the pedals */}
        <path d="M330 300 L352 402 L384 420" fill="none" stroke="#f8c537" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M372 296 L330 408 L350 438" fill="none" stroke="#f8c537" strokeWidth="10" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <circle cx="360" cy="452" r="24" fill="none" stroke="#f2f0f3" strokeWidth="8" />
    </svg>
  )
}
